import * as React from 'react';

import { DropdownInput, titleCase } from '../../index';
import { defaultLanguageOptions, defaultLanguages } from "../../utils/languageList";

interface LanguagePickerProps {
  language: string,
  languageOptions?: Array<{ value: string; label: string }>,
  updateLanguage(language: string): any
}

const renderLabel = (flag: string | undefined, label: string) => (
  <React.Fragment><img alt="" src={flag} /> {label}</React.Fragment>
);

const LanguagePicker = ({ language, updateLanguage, languageOptions }: LanguagePickerProps) => {
  const permittedLanguages: string[] = JSON.parse(window.postbuildEnv.PERMITTED_LANGUAGES);
  const options: Array<{value: string, label: React.ReactNode}> = React.useMemo(() => {
    if (languageOptions) {
      return languageOptions
        .filter(option => permittedLanguages.includes(option.value))
        .map(option => ({
          value: option.value,
          label: renderLabel(defaultLanguageOptions[option.value]?.flag, titleCase(option.label)),
        }));
    }
    return defaultLanguages.map(lang => ({
      value: lang,
      label: renderLabel(defaultLanguageOptions[lang]?.flag, defaultLanguageOptions[lang]?.label),
    }));
  }, [languageOptions, permittedLanguages]);

  const onChange = (option: { value: string}) => {
    const language = option.value;
    updateLanguage(language)
  }

  const value = options.find(opt => language === opt.value)

  return (
    <DropdownInput
      ariaLabel="Language for translation assistance"
      className="ell-language-selector medium white-border"
      handleChange={onChange}
      options={options}
      value={value}
    />
  )
}

export default LanguagePicker;
